import { useEffect, useState } from "react";
import { useAccount } from "./useAccount";
import { Avviso, Bottone, Campo, LinkTesto, PaginaAccount, Scheda } from "./ui";
import { C } from "../theme/tokens";

export default function InvitoPage({ onNavigate, token }) {
  const { imposta, api } = useAccount();
  const [info, setInfo] = useState(null);
  const [errore, setErrore] = useState(token ? null : "Manca il codice dell'invito: apri il link che trovi nell'email.");
  const [nome, setNome] = useState("");
  const [password, setPassword] = useState("");
  const [inCorso, setInCorso] = useState(false);

  useEffect(() => {
    if (!token) return;
    let vivo = true;
    api.infoInvito(token)
      .then((i) => { if (vivo) setInfo(i); })
      .catch((err) => { if (vivo) setErrore(err.message); });
    return () => { vivo = false; };
  }, [token, api]);

  const accetta = async (e) => {
    e.preventDefault();
    setInCorso(true); setErrore(null);
    try {
      const profilo = await api.accettaInvito(token, nome, password);
      imposta(profilo);
      onNavigate("anonymize");
    } catch (err) {
      setErrore(err.message);
    } finally {
      setInCorso(false);
    }
  };

  return (
    <PaginaAccount titolo="Invito al team" onBack={() => onNavigate("landing")}>
      <Scheda>
        {info && (
          <p style={{ fontSize: 14, color: C.textBody, lineHeight: 1.6, margin: "0 0 16px" }}>
            <strong>{info.invitato_da || "Un collega"}</strong> ti ha invitato a usare OBSCURA con il team di <strong>{info.azienda}</strong>. Entrerai come <strong>{info.email}</strong>: scegli un nome e una password.
          </p>
        )}
        {errore && <Avviso tipo="errore">{errore}</Avviso>}
        {info && (
          <form onSubmit={accetta}>
            <Campo etichetta="Il tuo nome" valore={nome} onChange={setNome} autoComplete="name" />
            <Campo etichetta="Password" tipo="password" valore={password} onChange={setPassword} autoComplete="new-password" minLength={10} aiuto="Almeno 10 caratteri." />
            <Bottone tipo="submit" pieno disabilitato={inCorso}>{inCorso ? "Un attimo..." : "Entra nel team"}</Bottone>
          </form>
        )}
        {!info && !errore && <p style={{ margin: 0, fontSize: 14, color: C.textNum }}>Lettura dell&apos;invito...</p>}
      </Scheda>
      <p style={{ fontSize: 13, color: C.textNum, textAlign: "center", margin: 0 }}>
        Hai gia&apos; un account? <LinkTesto onClick={() => onNavigate("accesso")}>Accedi</LinkTesto>
      </p>
    </PaginaAccount>
  );
}
